import React, { PureComponent, ReactNode } from "react";
import { AppContextType, AppLoadingState } from "../../AppContext";
import "./WasmLoadingStatus.css";
import InfoCard from "../layout_reuse/InfoCard";

interface Props {}
interface State {}

export default class WasmLoadingStatus extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  renderStatusWindowText = (loading: AppLoadingState) => {
    if (loading === AppLoadingState.FAILED) {
      return (
        <div className="app-loading-failed-text">
            <p>Failed to launch.</p>
            <p>Please try reloading the page.</p>
        </div>
      );
    }
    return <span className="app-loading-text">Loading spaghetti, one moment</span>;
  };

  render(): ReactNode {
    const { loading } = this.context;
    if (loading === AppLoadingState.READY) {
      return undefined;
    }
    return (
      <div className="app-loading-status-window">
        <InfoCard>{this.renderStatusWindowText(loading)}</InfoCard>
      </div>
    );
  }
}

WasmLoadingStatus.contextType = AppContextType;
